import styled from 'styled-components';

import * as StylesFilter from '~/components/filter/Filter.styles';

export const StyledFilterDropdownMenuContent = styled(
  StylesFilter.DropdownMenuContent
)<{ $maxHeight?: string }>`
  max-height: ${({ $maxHeight }) => $maxHeight};
`;
